import { makeObservable, observable } from "mobx";
import { ImMessage } from "@whatslly/types/tuvis-messaging/TuvisMessagingMessages";
import { ChannelType } from "@whatslly/types/tuvis-messaging/TuvisMessagingChannels";

export class IMMessage implements ImMessage {
  _id: string;
  orgId: string;
  messageId?: string;
  phoneNumberId: string;
  status: string;
  errorCode?: number;
  message: string | undefined;
  recipientNumber: number;
  senderNumber: number;
  createdAt: string;
  updatedAt: string;
  wabaCreatedAt: Date;
  wabaUpdatedAt: Date;
  quotedMsgId: string | undefined;
  file: ImMessage["file"];
  location: ImMessage["location"];
  contacts: ImMessage["contacts"];
  reactions: ImMessage["reactions"];
  templateName: string | undefined;
  height: number | undefined;
  width: number | undefined;
  direction: "sent" | "received" | "internal";
  type: string;
  channel: ChannelType;

  constructor(data: ImMessage) {
    this._id = data._id;
    this.orgId = data.orgId;
    this.messageId = data.messageId;
    this.phoneNumberId = data.phoneNumberId;
    this.status = data.status;
    this.errorCode = data.errorCode;
    this.message = data.message;
    this.recipientNumber = data.recipientNumber;
    this.senderNumber = data.senderNumber;
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt;
    this.wabaCreatedAt = new Date(data.wabaCreatedAt as unknown as string);
    this.wabaUpdatedAt = new Date(data.wabaUpdatedAt as unknown as string);
    this.quotedMsgId = data.quotedMsgId;
    this.file = data.file;
    this.location = data.location;
    this.contacts = data.contacts;
    this.reactions = data.reactions;
    this.templateName = data.templateName;
    this.height = data.height;
    this.width = data.width;
    this.direction = data.direction;
    this.type = data.type;
    this.channel = data.channel;

    makeObservable(this, {
      status: observable,
      reactions: observable,
    });
  }

  set ["reactions.sent"](data: Exclude<ImMessage["reactions"], undefined>[number]) {
    this.reactions = this.reactions?.filter((r) => !r.isSent) ?? [];
    this.reactions.push({ ...data, isSent: true });
  }
  set ["reactions.received"](data: Exclude<ImMessage["reactions"], undefined>[number]) {
    this.reactions = this.reactions?.filter((r) => r.isSent) ?? [];
    this.reactions.push({ ...data, isSent: false });
  }
}
